
import { IPlanificationProfileScheduler } from '@/entity/planification/planification-profile-scheduler';
import { Component, Prop, Vue } from 'vue-property-decorator';
import PrevisionalBudget from './previsional-budget.vue';
import { dateToString } from './calendar-helper';
import { NU } from '@t/type';

@Component({ components: { PrevisionalBudget } })
export default class GroupLabel extends Vue {
    @Prop({ required: true }) elemId!: string;
    @Prop({ required: true }) phase!: IPlanificationProfileScheduler;
    @Prop({ required: true }) hasCollapse!: boolean;
    @Prop({ required: true }) isShowNested!: boolean;
    @Prop({ required: true }) phaseTotalRate!: number;
    @Prop({ default: true }) isHideBudget!: boolean;
    @Prop({ default: true }) shiftBtnState!: boolean;
    @Prop({ default: true }) isSelectedShift!: boolean;
    @Prop({ default: true }) delBtnState!: boolean;
    @Prop({ default: true }) isSelectedDel!: boolean;

    convertDateToString(date: NU<Date | string>, currentFormat: string) {
        return dateToString(date, currentFormat);
    }

    get displayEmployeeName() {
        return this.phase.employee ? this.phase.employee.employeeDisplayName : '-';
    }

    get labelPhase() {
        return `${this.phase.contractLineLabel.toUpperCase()} `;
    }

    get profilCount() {
        const profilNumber = `profil${this.phase.profileNumber! > 1 ? '(s)' : ''}`;
        return `[${this.phase.profileNumber} ${profilNumber}]`;
    }

    get canUpdatePhase() {
        return this.phase.statusCode !== 'BLC';
    }

    get isBlock() {
        return this.phase.statusCode === 'BLC';
    }    

    get isEmployee() {
        return this.phase.employeeId && this.phase.employeeId.length > 0;
    }

    get isDisplayCheckbox(): boolean {
        /* si c'est un employee/profil, on affiche la checkbox */
        if (this.phase.parentPhaseId > 0) return true;

        /* on masque la checkbox que si le nombre de profil dans une phase est null ou zéro. */
        return (this.phase.profileNumber ?? 0) > 0;
    }

    check: boolean = true;
}
